module.exports = __webpack_public_path__ + "static/img/item-5-3-big.b7fde45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-5-3-big.jpg
// module id = HBnV
// module chunks = 2